module.exports = {
  specificPoints: {
    'Joinville - SC': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 80,
          finalPoints: 92,
          2022: 80,
          2023: 81,
          2024: 82,
          2025: 83,
          2026: 84,
          2027: 85,
          2028: 86,
          2029: 87,
          2030: 88,
          2031: 89,
          2032: 90,
          2033: 91,
          2034: 92
        },
        default: {
          initialYear: 2022,
          finalYear: 2035,
          initialPoints: 87,
          finalPoints: 100,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95,
          2031: 96,
          2032: 97,
          2033: 98,
          2034: 99,
          2035: 100
        }
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 90,
          finalPoints: 100,
          2022: 90,
          2023: 91,
          2024: 92,
          2025: 93,
          2026: 94,
          2027: 95,
          2028: 96,
          2029: 97,
          2030: 98,
          2031: 99,
          2032: 100,
          2033: 100,
          2034: 100
        },
        default: {
          initialYear: 2022,
          finalYear: 2035,
          initialPoints: 97,
          finalPoints: 105,
          2022: 97,
          2023: 98,
          2024: 99,
          2025: 100,
          2026: 101,
          2027: 102,
          2028: 103,
          2029: 104,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105,
          2035: 105
        }
      }
    },
    'Soledade - RS': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2030,
          initialPoints: 81,
          finalPoints: 89,
          2022: 81,
          2023: 82,
          2024: 83,
          2025: 84,
          2026: 85,
          2027: 86,
          2028: 87,
          2029: 88,
          2030: 89
        },
        default: {
          initialYear: 2022,
          finalYear: 2033,
          initialPoints: 86,
          finalPoints: 97,
          2022: 86,
          2023: 87,
          2024: 88,
          2025: 89,
          2026: 90,
          2027: 91,
          2028: 92,
          2029: 93,
          2030: 94,
          2031: 95,
          2032: 96,
          2033: 97
        }
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2030,
          initialPoints: 91,
          finalPoints: 97,
          2022: 91,
          2023: 92,
          2024: 93,
          2025: 94,
          2026: 95,
          2027: 96,
          2028: 97,
          2029: 97,
          2030: 97
        },
        default: {
          initialYear: 2022,
          finalYear: 2033,
          initialPoints: 96,
          finalPoints: 102,
          2022: 96,
          2023: 97,
          2024: 98,
          2025: 99,
          2026: 100,
          2027: 101,
          2028: 102,
          2029: 102,
          2030: 102,
          2031: 102,
          2032: 102,
          2033: 102
        }
      }
    },
    'RJ': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2045,
          initialPoints: 78,
          finalPoints: 90,
          2022: 78,
          2023: 79,
          2024: 79,
          2025: 80,
          2026: 80,
          2027: 81,
          2028: 81,
          2029: 82,
          2030: 82,
          2031: 83,
          2032: 83,
          2033: 84,
          2034: 84,
          2035: 85,
          2036: 85,
          2037: 86,
          2038: 86,
          2039: 87,
          2040: 87,
          2041: 88,
          2042: 88,
          2043: 89,
          2044: 89,
          2045: 90
        },
        default: {
          initialYear: 2022,
          finalYear: 2049,
          initialPoints: 86,
          finalPoints: 100,
          2022: 86,
          2023: 87,
          2024: 87,
          2025: 88,
          2026: 88,
          2027: 89,
          2028: 89,
          2029: 90,
          2030: 90,
          2031: 91,
          2032: 91,
          2033: 92,
          2034: 92,
          2035: 93,
          2036: 93,
          2037: 94,
          2038: 94,
          2039: 95,
          2040: 95,
          2041: 96,
          2042: 96,
          2043: 97,
          2044: 97,
          2045: 98,
          2046: 98,
          2047: 99,
          2048: 99,
          2049: 100
        }
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2045,
          initialPoints: 88,
          finalPoints: 98,
          2022: 88,
          2023: 89,
          2024: 89,
          2025: 90,
          2026: 90,
          2027: 91,
          2028: 91,
          2029: 92,
          2030: 92,
          2031: 93,
          2032: 93,
          2033: 94,
          2034: 94,
          2035: 95,
          2036: 95,
          2037: 96,
          2038: 96,
          2039: 97,
          2040: 97,
          2041: 98,
          2042: 98,
          2043: 98,
          2044: 98,
          2045: 98
        },
        default: {
          initialYear: 2022,
          finalYear: 2049,
          initialPoints: 96,
          finalPoints: 105,
          2022: 96,
          2023: 97,
          2024: 97,
          2025: 98,
          2026: 98,
          2027: 99,
          2028: 99,
          2029: 100,
          2030: 100,
          2031: 101,
          2032: 101,
          2033: 102,
          2034: 102,
          2035: 103,
          2036: 103,
          2037: 104,
          2038: 104,
          2039: 105,
          2040: 105,
          2041: 105,
          2042: 105,
          2043: 105,
          2044: 105,
          2045: 105,
          2046: 105,
          2047: 105,
          2048: 105,
          2049: 105
        }
      }
    },
    'PR': {
      'Mulher': {
        'Magistério': {
          initialYear: 2018,
          finalYear: 2033,
          initialPoints: 80,
          finalPoints: 95,
          2018: 80,
          2019: 81,
          2020: 82,
          2021: 83,
          2022: 84,
          2023: 85,
          2024: 86,
          2025: 87,
          2026: 88,
          2027: 89,
          2028: 90,
          2029: 91,
          2030: 92,
          2031: 93,
          2032: 94,
          2033: 95
        },
        default: {
          initialYear: 2018,
          finalYear: 2033,
          initialPoints: 85,
          finalPoints: 100,
          2018: 85,
          2019: 86,
          2020: 87,
          2021: 88,
          2022: 89,
          2023: 90,
          2024: 91,
          2025: 92,
          2026: 93,
          2027: 94,
          2028: 95,
          2029: 96,
          2030: 97,
          2031: 98,
          2032: 99,
          2033: 100
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2018,
          finalYear: 2028,
          initialPoints: 90,
          finalPoints: 100,
          2018: 90,
          2019: 91,
          2020: 92,
          2021: 93,
          2022: 94,
          2023: 95,
          2024: 96,
          2025: 97,
          2026: 98,
          2027: 99,
          2028: 100
        },
        default: {
          initialYear: 2018,
          finalYear: 2028,
          initialPoints: 95,
          finalPoints: 105,
          2018: 95,
          2019: 96,
          2020: 97,
          2021: 98,
          2022: 99,
          2023: 100,
          2024: 101,
          2025: 102,
          2026: 103,
          2027: 104,
          2028: 105
        },
      },
    },
    'SC': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2036,
          initialPoints: 76,
          finalPoints: 90,
          2022: 76,
          2023: 77,
          2024: 78,
          2025: 79,
          2026: 80,
          2027: 81,
          2028: 82,
          2029: 83,
          2030: 84,
          2031: 85,
          2032: 86,
          2033: 87,
          2034: 88,
          2035: 89,
          2036: 90
        },
        default: {
          initialYear: 2022,
          finalYear: 2031,
          initialPoints: 86,
          finalPoints: 95,
          2022: 86,
          2023: 87,
          2024: 88,
          2025: 89,
          2026: 90,
          2027: 91,
          2028: 92,
          2029: 93,
          2030: 94,
          2031: 95
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2031,
          initialPoints: 86,
          finalPoints: 95,
          2022: 86,
          2023: 87,
          2024: 88,
          2025: 89,
          2026: 90,
          2027: 91,
          2028: 92,
          2029: 93,
          2030: 94,
          2031: 95
        },
        default: {
          initialYear: 2022,
          finalYear: 2026,
          initialPoints: 96,
          finalPoints: 100,
          2022: 96,
          2023: 97,
          2024: 98,
          2025: 99,
          2026: 100
        },
      },
    },
    'TO': {
      'Mulher': {
        'Magistério': {
          initialYear: 2023,
          finalYear: 2052,
          initialPoints: 76,
          finalPoints: 90,
          2023: 76,
          2024: 77,
          2025: 77,
          2026: 78,
          2027: 78,
          2028: 79,
          2029: 79,
          2030: 80,
          2031: 80,
          2032: 81,
          2033: 81,
          2034: 82,
          2035: 82,
          2036: 83,
          2037: 83,
          2038: 84,
          2039: 84,
          2040: 85,
          2041: 85,
          2042: 86,
          2043: 86,
          2044: 87,
          2045: 87,
          2046: 88,
          2047: 88,
          2048: 89,
          2049: 89,
          2050: 90,
          2051: 90,
          2052: 90
        },
        'Especial': {
          initialYear: 2023,
          finalYear: 2042,
          initialPoints: 86,
          finalPoints: 96,
          2023: 86,
          2024: 87,
          2025: 87,
          2026: 88,
          2027: 88,
          2028: 89,
          2029: 89,
          2030: 90,
          2031: 90,
          2032: 91,
          2033: 91,
          2034: 92,
          2035: 92,
          2036: 93,
          2037: 93,
          2038: 94,
          2039: 94,
          2040: 95,
          2041: 95,
          2042: 96
        },
        default: {
          initialYear: 2023,
          finalYear: 2052,
          initialPoints: 86,
          finalPoints: 100,
          2023: 86,
          2024: 87,
          2025: 87,
          2026: 88,
          2027: 88,
          2028: 89,
          2029: 89,
          2030: 90,
          2031: 90,
          2032: 91,
          2033: 91,
          2034: 92,
          2035: 92,
          2036: 93,
          2037: 93,
          2038: 94,
          2039: 94,
          2040: 95,
          2041: 95,
          2042: 96,
          2043: 96,
          2044: 97,
          2045: 97,
          2046: 98,
          2047: 98,
          2048: 99,
          2049: 99,
          2050: 100,
          2051: 100,
          2052: 100
        }
      },
      'Homem': {
        'Magistério': {
          initialYear: 2023,
          finalYear: 2052,
          initialPoints: 86,
          finalPoints: 95,
          2023: 86,
          2024: 87,
          2025: 87,
          2026: 88,
          2027: 88,
          2028: 89,
          2029: 89,
          2030: 90,
          2031: 90,
          2032: 91,
          2033: 91,
          2034: 92,
          2035: 92,
          2036: 93,
          2037: 93,
          2038: 94,
          2039: 94,
          2040: 95,
          2041: 95,
          2042: 95,
          2043: 95,
          2044: 95,
          2045: 95,
          2046: 95,
          2047: 95,
          2048: 95,
          2049: 95,
          2050: 95,
          2051: 95,
          2052: 95
        },
        'Especial': {
          initialYear: 2023,
          finalYear: 2042,
          initialPoints: 86,
          finalPoints: 96,
          2023: 86,
          2024: 87,
          2025: 87,
          2026: 88,
          2027: 88,
          2028: 89,
          2029: 89,
          2030: 90,
          2031: 90,
          2032: 91,
          2033: 91,
          2034: 92,
          2035: 92,
          2036: 93,
          2037: 93,
          2038: 94,
          2039: 94,
          2040: 95,
          2041: 95,
          2042: 96
      },
        default: {
          initialYear: 2023,
          finalYear: 2052,
          initialPoints: 96,
          finalPoints: 105,
          2023: 96,
          2024: 97,
          2025: 97,
          2026: 98,
          2027: 98,
          2028: 99,
          2029: 99,
          2030: 100,
          2031: 100,
          2032: 101,
          2033: 101,
          2034: 102,
          2035: 102,
          2036: 103,
          2037: 103,
          2038: 104,
          2039: 104,
          2040: 105,
          2041: 105,
          2042: 105,
          2043: 105,
          2044: 105,
          2045: 105,
          2046: 105,
          2047: 105,
          2048: 105,
          2049: 105,
          2050: 105,
          2051: 105,
          2052: 105
        }
      }
    },
    'MG': {
      'Mulher': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2032,
          initialPoints: 81,
          finalPoints: 92,
          2020: 81,
          2021: 81,
          2022: 82,
          2023: 83,
          2024: 84,
          2025: 85,
          2026: 86,
          2027: 87,
          2028: 88,
          2029: 89,
          2030: 90,
          2031: 91,
          2032: 92
        },
        default: {
          initialYear: 2020,
          finalYear: 2035,
          initialPoints: 86,
          finalPoints: 100,
          useMonths: true,
          2019: {
            points: 86
          },
          2020: {
            month: 9,
            points: 86
          },
          2021: {
            points: 86
          },
          2022: {
            month: 4,
            points: 87
          },
          2023: {
            month: 7,
            points: 88
          },
          2024: {
            month: 10,
            points: 89
          },
          2025: {
            month: 1,
            points: 90
          },
          2026: {
            month: 4,
            points: 91
          },
          2027: {
            month: 7,
            points: 92
          },
          2028: {
            month: 10,
            points: 93
          },
          2029: {
            month: 1,
            points: 94
          },
          2030: {
            month: 4,
            points: 95
          },
          2031: {
            month: 7,
            points: 96
          },
          2032: {
            month: 10,
            points: 97
          },
          2033: {
            month: 1,
            points: 98
          },
          2034: {
            month: 4,
            points: 99
          },
          2035: {
            month: 7,
            points: 100
          },
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2032,
          initialPoints: 92,
          finalPoints: 100,
          2020: 92,
          2021: 92,
          2022: 93,
          2023: 94,
          2024: 95,
          2025: 96,
          2026: 97,
          2027: 98,
          2028: 99,
          2029: 100,
          2030: 100,
          2031: 100,
          2032: 100
        },
        default: {
          initialYear: 2020,
          finalYear: 2035,
          initialPoints: 97,
          finalPoints: 105,
          useMonths: true,
          2019: {
            points: 97
          },
          2020: {
            month: 9,
            points: 97
          },
          2021: {
            points: 97
          },
          2022: {
            month: 4,
            points: 98
          },
          2023: {
            month: 7,
            points: 99
          },
          2024: {
            month: 10,
            points: 100
          },
          2025: {
            month: 1,
            points: 101
          },
          2026: {
            month: 4,
            points: 102
          },
          2027: {
            month: 7,
            points: 103
          },
          2028: {
            month: 10,
            points: 104
          },
          2029: {
            month: 1,
            points: 105
          },
          2030: {
            month: 4,
            points: 105
          },
          2031: {
            month: 7,
            points: 105
          },
          2032: {
            month: 10,
            points: 105
          },
          2033: {
            month: 1,
            points: 105
          },
          2034: {
            month: 4,
            points: 105
          },
          2035: {
            month: 7,
            points: 105
          },
        },
      },
    },
    'São José dos Campos - SP': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2030,
          initialPoints: 86,
          finalPoints: 92,
          2022: 86,
          2023: 86,
          2024: 86,
          2025: 87,
          2026: 88,
          2027: 89,
          2028: 90,
          2029: 91,
          2030: 92
        },
        default: {
          initialYear: 2022,
          finalYear: 2033,
          initialPoints: 91,
          finalPoints: 100,
          2022: 91,
          2023: 91,
          2024: 91,
          2025: 92,
          2026: 93,
          2027: 94,
          2028: 95,
          2029: 96,
          2030: 97,
          2031: 98,
          2032: 99,
          2033: 100,
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2030,
          initialPoints: 96,
          finalPoints: 100,
          2022: 96,
          2023: 96,
          2024: 96,
          2025: 97,
          2026: 98,
          2027: 99,
          2028: 100,
          2029: 100,
          2030: 100
        },
        default: {
          initialYear: 2022,
          finalYear: 2033,
          initialPoints: 100,
          finalPoints: 105,
          2022: 100,
          2023: 100,
          2024: 100,
          2025: 101,
          2026: 102,
          2027: 103,
          2028: 104,
          2029: 105,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
        },
      },
    },
    'Jacareí - SP': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 81,
          finalPoints: 92,
          2022: 81,
          2023: 81,
          2024: 82,
          2025: 83,
          2026: 84,
          2027: 85,
          2028: 86,
          2029: 87,
          2030: 88,
          2031: 89,
          2032: 90,
          2033: 91,
          2034: 92
        },
        default: {
          initialYear: 2022,
          finalYear: 2036,
          initialPoints: 87,
          finalPoints: 100,
          2022: 87,
          2023: 87,
          2024: 88,
          2025: 89,
          2026: 90,
          2027: 91,
          2028: 92,
          2029: 93,
          2030: 94,
          2031: 95,
          2032: 96,
          2033: 97,
          2034: 98,
          2035: 99,
          2036: 100,
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 91,
          finalPoints: 100,
          2022: 91,
          2023: 91,
          2024: 92,
          2025: 93,
          2026: 94,
          2027: 95,
          2028: 96,
          2029: 97,
          2030: 98,
          2031: 99,
          2032: 100,
          2033: 100,
          2034: 100
        },
        default: {
          initialYear: 2022,
          finalYear: 2036,
          initialPoints: 97,
          finalPoints: 105,
          2022: 97,
          2023: 97,
          2024: 98,
          2025: 99,
          2026: 100,
          2027: 101,
          2028: 102,
          2029: 103,
          2030: 104,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105,
          2035: 105,
          2036: 105,
        },
      },
    },
    'RGPS': {
      'Mulher': {
        default: {
          initialYear: 2019,
          finalYear: 2033,
          initialPoints: 86,
          finalPoints: 100,
          2019: 86,
          2020: 87,
          2021: 88,
          2022: 89,
          2023: 90,
          2024: 91,
          2025: 92,
          2026: 93,
          2027: 94,
          2028: 95,
          2029: 96,
          2030: 97,
          2031: 98,
          2032: 99,
          2033: 100,
        },
        'Magistério': {
          initialYear: 2019,
          finalYear: 2030,
          initialPoints: 81,
          finalPoints: 92,
          2019: 81,
          2020: 82,
          2021: 83,
          2022: 84,
          2023: 85,
          2024: 86,
          2025: 87,
          2026: 88,
          2027: 89,
          2028: 90,
          2029: 91,
          2030: 92,
        },
        'Lei n. 13.183/2015': {
          initialYear: 2018,
          finalYear: 2019,
          initialPoints: 85,
          finalPoints: 86,
          2018: 85,
          2019: 86
        },
        'Lei n. 13.183/2015 - Magistério': {
          initialYear: 2018,
          finalYear: 2019,
          initialPoints: 80,
          finalPoints: 81,
          2018: 80,
          2019: 81
        }
      },
      'Homem': {
        default: {
          initialYear: 2019,
          finalYear: 2028,
          initialPoints: 96,
          finalPoints: 105,
          2019: 96,
          2020: 97,
          2021: 98,
          2022: 99,
          2023: 100,
          2024: 101,
          2025: 102,
          2026: 103,
          2027: 104,
          2028: 105,
        },
        'Magistério': {
          initialYear: 2019,
          finalYear: 2028,
          initialPoints: 91,
          finalPoints: 100,
          2019: 91,
          2020: 92,
          2021: 93,
          2022: 94,
          2023: 95,
          2024: 96,
          2025: 97,
          2026: 98,
          2027: 99,
          2028: 100,
        },
        'Lei n. 13.183/2015': {
          initialYear: 2018,
          finalYear: 2019,
          initialPoints: 95,
          finalPoints: 96,
          2018: 95,
          2019: 96
        },
        'Lei n. 13.183/2015 - Magistério': {
          initialYear: 2018,
          finalYear: 2019,
          initialPoints: 90,
          finalPoints: 91,
          2018: 90,
          2019: 91
        }
      },
    },
    PI: {
      Mulher: {
          default: {
            initialYear: 2020,
            finalYear: 2047,
            initialPoints: 86,
            finalPoints: 100,
            2020: 86,
            2021: 87,
            2022: 87,
            2023: 88,
            2024: 88,
            2025: 89,
            2026: 89,
            2027: 90,
            2028: 90,
            2029: 91,
            2030: 91,
            2031: 92,
            2032: 92,
            2033: 93,
            2034: 93,
            2035: 94,
            2036: 94,
            2037: 95,
            2038: 95,
            2039: 96,
            2040: 96,
            2041: 97,
            2042: 97,
            2043: 98,
            2044: 98,
            2045: 99,
            2046: 99,
            2047: 100,
          },
          "Magistério": {
            initialYear: 2020,
            finalYear: 2041,
            initialPoints: 81,
            finalPoints: 92,
            2020: 81,
            2021: 82,
            2022: 82,
            2023: 83,
            2024: 83,
            2025: 84,
            2026: 84,
            2027: 85,
            2028: 85,
            2029: 86,
            2030: 86,
            2031: 87,
            2032: 87,
            2033: 88,
            2034: 88,
            2035: 89,
            2036: 89,
            2037: 90,
            2038: 90,
            2039: 91,
            2040: 91,
            2041: 92,
          }
      },
      Homem: {
        default: {
          initialYear: 2020,
          finalYear: 2037,
          initialPoints: 96,
          finalPoints: 105,
          2020: 96,
          2021: 97,
          2022: 97,
          2023: 98,
          2024: 98,
          2025: 99,
          2026: 99,
          2027: 100,
          2028: 100,
          2029: 101,
          2030: 101,
          2031: 102,
          2032: 102,
          2033: 103,
          2034: 103,
          2035: 104,
          2036: 104,
          2037: 105,
        },
        "Magistério": {
          initialYear: 2020,
            finalYear: 2037,
            initialPoints: 91,
            finalPoints: 100,
            2020: 91,
            2021: 92,
            2022: 92,
            2023: 93,
            2024: 93,
            2025: 94,
            2026: 94,
            2027: 95,
            2028: 95,
            2029: 96,
            2030: 96,
            2031: 97,
            2032: 97,
            2033: 98,
            2034: 98,
            2035: 99,
            2036: 99,
            2037: 100,
        }
      }
    },
    'Fortaleza - CE': {
            Mulher: {
                Magistério: {
                    initialYear: 2021,
                    finalYear: 2027,
                    initialPoints: 81,
                    finalPoints: 86,
                    useMonths: true,
                    2021: {
                        points: 81,
                    },
                    2022: {
                        points: 82,
                    },
                    2023: {
                        month: 4,
                        points: 83,
                    },
                    2024: {
                        month: 7,
                        points: 84,
                    },
                    2025: {
                        month: 10,
                        points: 85,
                    },
                    2026: {
                        points: 85,
                    },
                    2027: {
                        points: 86,
                    },
                },
                default: {
                    initialYear: 2021,
                    finalYear: 2027,
                    initialPoints: 86,
                    finalPoints: 91,
                    useMonths: true,
                    2021: {
                        points: 86,
                    },
                    2022: {
                        points: 87,
                    },
                    2023: {
                        month: 4,
                        points: 88,
                    },
                    2024: {
                        month: 7,
                        points: 89,
                    },
                    2025: {
                        month: 10,
                        points: 90,
                    },
                    2026: {
                        points: 90,
                    },
                    2027: {
                        points: 91,
                    },
                },
            },
            Homem: {
                Magistério: {
                    initialYear: 2021,
                    finalYear: 2027,
                    initialPoints: 91,
                    finalPoints: 94,
                    useMonths: true,
                    2021: {
                        points: 91,
                    },
                    2022: {
                        points: 92,
                    },
                    2023: {
                        month: 4,
                        points: 93,
                    },
                    2024: {
                        month: 7,
                        points: 94,
                    },
                    2025: {
                        month: 10,
                        points: 94,
                    },
                    2026: {
                        points: 94,
                    },
                    2027: {
                        points: 99,
                    },
                },
                default: {
                    initialYear: 2021,
                    finalYear: 2027,
                    initialPoints: 96,
                    finalPoints: 99,
                    useMonths: true,
                    2021: {
                        points: 96,
                    },
                    2022: {
                        points: 97,
                    },
                    2023: {
                        month: 4,
                        points: 98,
                    },
                    2024: {
                        month: 7,
                        points: 99,
                    },
                    2025: {
                        month: 10,
                        points: 99,
                    },
                    2026: {
                        points: 99,
                    },
                    2027: {
                        points: 99,
                    },
                },
            },
        },
    'Cerqueira César - SP': {
      'Mulher': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2049,
          initialPoints: 75,
          finalPoints: 100,
          2020: 75,
          2021: 75,
          2022: 75,
          2023: 75,
          2024: 75,
          2025: 76,
          2026: 77,
          2027: 78,
          2028: 79,
          2029: 80,
          2030: 81,
          2031: 82,
          2032: 83,
          2033: 84,
          2034: 85,
          2035: 86,
          2036: 87,
          2037: 88,
          2038: 89,
          2039: 90,
          2040: 91,
          2041: 92,
          2042: 93,
          2043: 94,
          2044: 95,
          2045: 96,
          2046: 97,
          2047: 98,
          2048: 99,
          2049: 100
        },
        default: {
          initialYear: 2020,
          finalYear: 2039,
          initialPoints: 85,
          finalPoints: 100,
          2020: 85,
          2021: 85,
          2022: 85,
          2023: 85,
          2024: 85,
          2025: 86,
          2026: 87,
          2027: 88,
          2028: 89,
          2029: 90,
          2030: 91,
          2031: 92,
          2032: 93,
          2033: 94,
          2034: 95,
          2035: 96,
          2036: 97,
          2037: 98,
          2038: 99,
          2039: 100
        }
      },
      'Homem': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2049,
          initialPoints: 85,
          finalPoints: 105,
          2020: 85,
          2021: 85,
          2022: 85,
          2023: 85,
          2024: 85,
          2025: 86,
          2026: 87,
          2027: 88,
          2028: 89,
          2029: 90,
          2030: 91,
          2031: 92,
          2032: 93,
          2033: 94,
          2034: 95,
          2035: 96,
          2036: 97,
          2037: 98,
          2038: 99,
          2039: 100,
          2040: 101,
          2041: 102,
          2042: 103,
          2043: 104,
          2044: 105,
          2045: 105,
          2046: 105,
          2047: 105,
          2048: 105,
          2049: 105
        },
        default: {
          initialYear: 2020,
          finalYear: 2039,
          initialPoints: 95,
          finalPoints: 105,
          2020: 95,
          2021: 95,
          2022: 95,
          2023: 95,
          2024: 95,
          2025: 96,
          2026: 97,
          2027: 98,
          2028: 99,
          2029: 100,
          2030: 101,
          2031: 102,
          2032: 103,
          2033: 104,
          2034: 105,
          2035: 105,
          2036: 105,
          2037: 105,
          2038: 105,
          2039: 105
        }
      }
    },
    default: {
      'Mulher': {
        'Magistério': {
          initialYear: 2018,
          finalYear: 2030,
          initialPoints: 80,
          finalPoints: 92,
          2018: 80,
          2019: 81,
          2020: 82,
          2021: 83,
          2022: 84,
          2023: 85,
          2024: 86,
          2025: 87,
          2026: 88,
          2027: 89,
          2028: 90,
          2029: 91,
          2030: 92,
        },
        default: {
          initialYear: 2018,
          finalYear: 2033,
          initialPoints: 85,
          finalPoints: 100,
          2018: 85,
          2019: 86,
          2020: 87,
          2021: 88,
          2022: 89,
          2023: 90,
          2024: 91,
          2025: 92,
          2026: 93,
          2027: 94,
          2028: 95,
          2029: 96,
          2030: 97,
          2031: 98,
          2032: 99,
          2033: 100
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2018,
          finalYear: 2028,
          initialPoints: 90,
          finalPoints: 100,
          2018: 90,
          2019: 91,
          2020: 92,
          2021: 93,
          2022: 94,
          2023: 95,
          2024: 96,
          2025: 97,
          2026: 98,
          2027: 99,
          2028: 100
        },
        default: {
          initialYear: 2018,
          finalYear: 2028,
          initialPoints: 95,
          finalPoints: 105,
          2018: 95,
          2019: 96,
          2020: 97,
          2021: 98,
          2022: 99,
          2023: 100,
          2024: 101,
          2025: 102,
          2026: 103,
          2027: 104,
          2028: 105
        },
      },
    },
    'Porto Alegre - RS': {
      'Mulher': {
        'Para ingresso até 01/01/2004 e 15 anos de carreira municipal': {
          initialYear: 2021,
          finalYear: 2030,
          initialPoints: 86,
          finalPoints: 95,
          2021: 86,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95
        },
        'Para ingresso até 01/01/2004 e 15 anos de carreira municipal e magistério': {
          initialYear: 2021,
          finalYear: 2027,
          initialPoints: 81,
          finalPoints: 87,
          2021: 81,
          2022: 82,
          2023: 83,
          2024: 84,
          2025: 85,
          2026: 86,
          2027: 87
        },
        'Tabela padrão': {
          initialYear: 2021,
          finalYear: 2035,
          initialPoints: 86,
          finalPoints: 100,
          2021: 86,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95,
          2031: 96,
          2032: 97,
          2033: 98,
          2034: 99,
          2035: 100
        },
        'Tabela padrão magistério': {
          initialYear: 2021,
          finalYear: 2032,
          initialPoints: 81,
          finalPoints: 92,
          2021: 81,
          2022: 82,
          2023: 83,
          2024: 84,
          2025: 85,
          2026: 86,
          2027: 87,
          2028: 88,
          2029: 89,
          2030: 90,
          2031: 91,
          2032: 92
        }
      },
      'Homem': {
        'Para ingresso até 01/01/2004 e 15 anos de carreira municipal': {
          initialYear: 2021,
          finalYear: 2030,
          initialPoints: 96,
          finalPoints: 100,
          2021: 96,
          2022: 97,
          2023: 98,
          2024: 99,
          2025: 100,
          2026: 100,
          2027: 100,
          2028: 100,
          2029: 100,
          2030: 100
        },
        'Para ingresso até 01/01/2004 e 15 anos de carreira municipal e magistério': {
          initialYear: 2021,
          finalYear: 2027,
          initialPoints: 91,
          finalPoints: 95,
          2021: 91,
          2022: 92,
          2023: 93,
          2024: 94,
          2025: 95,
          2026: 95,
          2027: 95
        },
        'Tabela padrão': {
          initialYear: 2021,
          finalYear: 2035,
          initialPoints: 96,
          finalPoints: 105,
          2021: 96,
          2022: 97,
          2023: 98,
          2024: 99,
          2025: 100,
          2026: 101,
          2027: 102,
          2028: 103,
          2029: 104,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105,
          2035: 105
        },
        'Tabela padrão magistério': {
          initialYear: 2021,
          finalYear: 2032,
          initialPoints: 91,
          finalPoints: 100,
          2021: 91,
          2022: 92,
          2023: 93,
          2024: 94,
          2025: 95,
          2026: 96,
          2027: 97,
          2028: 98,
          2029: 99,
          2030: 100,
          2031: 100,
          2032: 100
        }
      }
    },
    'Curitiba - PR': {
      'Mulher': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2031,
          initialPoints: 83,
          finalPoints: 92,
          2022: 83,
          2023: 84,
          2024: 85,
          2025: 86,
          2026: 87,
          2027: 88,
          2028: 89,
          2029: 90,
          2030: 91,
          2031: 92
        },
        default: {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 88,
          finalPoints: 100,
          2022: 88,
          2023: 89,
          2024: 90,
          2025: 91,
          2026: 92,
          2027: 93,
          2028: 94,
          2029: 95,
          2030: 96,
          2031: 97,
          2032: 98,
          2033: 99,
          2034: 100
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2022,
          finalYear: 2031,
          initialPoints: 93,
          finalPoints: 100,
          2022: 93,
          2023: 94,
          2024: 95,
          2025: 96,
          2026: 97,
          2027: 98,
          2028: 99,
          2029: 100,
          2030: 100,
          2031: 100
        },
        default: {
          initialYear: 2022,
          finalYear: 2034,
          initialPoints: 98,
          finalPoints: 105,
          2022: 98,
          2023: 99,
          2024: 100,
          2025: 101,
          2026: 102,
          2027: 103,
          2028: 104,
          2029: 105,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105
        },
      },
    },
    'Francisco Beltrão - PR': {
      'Mulher': {
        'Magistério': {
          initialYear: 2021,
          finalYear: 2032,
          initialPoints: 81,
          finalPoints: 92,
          2021: 81,
          2022: 82,
          2023: 83,
          2024: 84,
          2025: 85,
          2026: 86,
          2027: 87,
          2028: 88,
          2029: 89,
          2030: 90,
          2031: 91,
          2032: 92
        },
        default: {
          initialYear: 2021,
          finalYear: 2035,
          initialPoints: 86,
          finalPoints: 1100,
          2021: 86,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95,
          2031: 96,
          2032: 97,
          2033: 98,
          2034: 99,
          2035: 100,
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2021,
          finalYear: 2032,
          initialPoints: 91,
          finalPoints: 100,
          2021: 91,
          2022: 92,
          2023: 93,
          2024: 94,
          2025: 95,
          2026: 96,
          2027: 97,
          2028: 98,
          2029: 99,
          2030: 100,
          2031: 100,
          2032: 100
        },
        default: {
          initialYear: 2021,
          finalYear: 2035,
          initialPoints: 96,
          finalPoints: 105,
          2021: 96,
          2022: 97,
          2023: 98,
          2024: 99,
          2025: 100,
          2026: 101,
          2027: 102,
          2028: 103,
          2029: 104,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105,
          2035: 105,
        },
      },
    },
    'Londrina - PR': {
      'Mulher': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2038,
          initialPoints: 77,
          finalPoints: 95,
          2020: 77,
          2021: 78,
          2022: 79,
          2023: 80,
          2024: 81,
          2025: 82,
          2026: 83,
          2027: 84,
          2028: 85,
          2029: 86,
          2030: 87,
          2031: 88,
          2032: 89,
          2033: 90,
          2034: 91,
          2035: 92,
          2036: 93,
          2037: 94,
          2038: 95,
        },
        default: {
          initialYear: 2020,
          finalYear: 2035,
          initialPoints: 85,
          finalPoints: 100,
          2020: 85,
          2021: 86,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95,
          2031: 96,
          2032: 97,
          2033: 98,
          2034: 99,
          2035: 100,
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2020,
          finalYear: 2038,
          initialPoints: 85,
          finalPoints: 100,
          2020: 85,
          2021: 86,
          2022: 87,
          2023: 88,
          2024: 89,
          2025: 90,
          2026: 91,
          2027: 92,
          2028: 93,
          2029: 94,
          2030: 95,
          2031: 96,
          2032: 97,
          2033: 98,
          2034: 99,
          2035: 100,
          2036: 100,
          2037: 100,
          2038: 100,
        },
        default: {
          initialYear: 2020,
          finalYear: 2035,
          initialPoints: 95,
          finalPoints: 105,
          2020: 95,
          2021: 96,
          2022: 97,
          2023: 98,
          2024: 99,
          2025: 100,
          2026: 101,
          2027: 102,
          2028: 103,
          2029: 104,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
          2034: 105,
          2035: 105,
        },
      },
    },
    'Campo Mourão - PR': {
      'Mulher': {
        'Magistério': {
          initialYear: 2021,
          finalYear: 2030,
          initialPoints: 83,
          finalPoints: 92,
          2021: 83,
          2022: 84,
          2023: 85,
          2024: 86,
          2025: 87,
          2026: 88,
          2027: 89,
          2028: 90,
          2029: 91,
          2030: 92,
        },
        default: {
          initialYear: 2021,
          finalYear: 2033,
          initialPoints: 88,
          finalPoints: 100,
          2021: 88,
          2022: 89,
          2023: 90,
          2024: 91,
          2025: 92,
          2026: 93,
          2027: 94,
          2028: 95,
          2029: 96,
          2030: 97,
          2031: 98,
          2032: 99,
          2033: 100,
        },
      },
      'Homem': {
        'Magistério': {
          initialYear: 2021,
          finalYear: 2030,
          initialPoints: 93,
          finalPoints: 100,
          2021: 93,
          2022: 94,
          2023: 95,
          2024: 96,
          2025: 97,
          2026: 98,
          2027: 99,
          2028: 100,
          2029: 100,
          2030: 100,
        },
        default: {
          initialYear: 2021,
          finalYear: 2033,
          initialPoints: 98,
          finalPoints: 105,
          2021: 98,
          2022: 99,
          2023: 100,
          2024: 101,
          2025: 102,
          2026: 103,
          2027: 104,
          2028: 105,
          2029: 105,
          2030: 105,
          2031: 105,
          2032: 105,
          2033: 105,
        },
      },
    },
    'Campos dos Goytacazes - RJ': {
      Mulher: {
        "Magisterio 2022": {
          initialYear: 2022,
          finalYear: 2024,
          initialPoints: 82,
          finalPoints: 84,
          "2022": 82,
          "2023": 83,
          "2024": 84
        },
        "Magisterio 2024": {
          initialYear: 2024,
          finalYear: 2033,
          initialPoints: 83,
          finalPoints: 92,
          "2024": 83,
          "2025": 84,
          "2026": 85,
          "2027": 86,
          "2028": 87,
          "2029": 88,
          "2030": 89,
          "2031": 90,
          "2032": 91,
          "2033": 92
        },
        "Servidores 2024": {
          initialYear: 2024,
          finalYear: 2037,
          initialPoints: 87,
          finalPoints: 100,
          "2024": 87,
          "2025": 88,
          "2026": 89,
          "2027": 90,
          "2028": 91,
          "2029": 92,
          "2030": 93,
          "2031": 94,
          "2032": 95,
          "2033": 96,
          "2034": 97,
          "2035": 98,
          "2036": 99,
          "2037": 100
        },
        default: {
          initialYear: 2024,
          finalYear: 2037,
          initialPoints: 87,
          finalPoints: 100,
          "2024": 87,
          "2025": 88,
          "2026": 89,
          "2027": 90,
          "2028": 91,
          "2029": 92,
          "2030": 93,
          "2031": 94,
          "2032": 95,
          "2033": 96,
          "2034": 97,
          "2035": 98,
          "2036": 99,
          "2037": 100
        }
      },
      Homem: {
        "Magisterio 2022": {
          initialYear: 2022,
          finalYear: 2024,
          initialPoints: 92,
          finalPoints: 94,
          "2022": 92,
          "2023": 93,
          "2024": 94
        },
        "Magisterio 2024": {
          initialYear: 2024,
          finalYear: 2033,
          initialPoints: 93,
          finalPoints: 100,
          "2024": 93,
          "2025": 94,
          "2026": 95,
          "2027": 96,
          "2028": 97,
          "2029": 98,
          "2030": 99,
          "2031": 100,
          "2032": 100,
          "2033": 100
        },
        "Servidores 2024": {
          initialYear: 2024,
          finalYear: 2037,
          initialPoints: 97,
          finalPoints: 105,
          "2024": 97,
          "2025": 98,
          "2026": 99,
          "2027": 100,
          "2028": 101,
          "2029": 102,
          "2030": 103,
          "2031": 104,
          "2032": 105,
          "2033": 105,
          "2034": 105,
          "2035": 105,
          "2036": 105,
          "2037": 105
        },
        default: {
          initialYear: 2024,
          finalYear: 2037,
          initialPoints: 97,
          finalPoints: 105,
          "2024": 97,
          "2025": 98,
          "2026": 99,
          "2027": 100,
          "2028": 101,
          "2029": 102,
          "2030": 103,
          "2031": 104,
          "2032": 105,
          "2033": 105,
          "2034": 105,
          "2035": 105,
          "2036": 105,
          "2037": 105
        }
      }
    },
  }
}
